import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
import { FC, useEffect, useRef, useState } from "react";
import "../../../App.css";
import toGroupLayers, { weatherLayerGroup } from "../weatherLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseTsunami } from "@fortawesome/free-solid-svg-icons";
import { LocationMarkerPopup } from "../../MainWindow";
import Tooltip from "@mui/material/Tooltip";
import { allWeatherMapECMWF, allWeatherMapICON } from "../weatherLayer";
import { weatherMapECMF, weatherMapICON } from "../weatherLayer";
import { getGlobalLayer } from "../../MainWindow";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { ecmf, ICON } from "../weatherLayer";
import { ThemeProvider, useTheme } from "../../../theme/ThemeContext";
import { useMenu } from "../../../roundMenuContext/roundMenuContext";
import {
  ecmf3hEnd,
  ecmf3hInterval,
  ecmf3hStart,
  ecmf6hEnd,
  ecmf6hInterval,
  ecmf6hStart,
  icon1hInterval,
  icon1hStart,
  icon1hEnd,
  icon3hInterval,
  icon3hStart,
  icon3hEnd,
  layerStartDate,
  layerIconStartDate,
} from "../../../TimeLine/BackgroundMapTimeLine/TimeLineService";
import { useMapLayersContext } from "../../../provider/MapLayers";

let isButtonClicked: boolean = false;
let tidesMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let tidesMapIcon: Map<string, ImageLayer<ImageWMS>> = new Map();
let isDateLoadModel: boolean = true;

interface TidesProps {
  setTimeLayer: (layer: string) => void;
  weatherlayerState: string;
  senddValueFromTides: (value: string) => void;
  timeLineHour: string;
  timeLineDate: string;
  selectModel: string;
}

const Waves: React.FC<TidesProps> = ({
  setTimeLayer,
  weatherlayerState,
  senddValueFromTides,
  timeLineHour,
  timeLineDate,
  selectModel,
}) => {
  const {
    loadLayerInMap,
    selectLayerInMap,
    set1Order,
    setIsWavesLoad,
    isWavesLoad,
  } = useMapLayersContext();
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [timeLineCounter, setTimeLineCounter] = useState<number>();
  const [hoveredTights, setHoveredTights] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();

  useEffect(() => {
    if (weatherlayerState === "tidesnot") {
      if (selectModel === "ICON") {
        try {
          const layer = tidesMapIcon.get(timeLineDate + "-" + timeLineHour);
      
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "tides");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      } else {
        try {
          const layer = tidesMap.get(timeLineDate + "-" + timeLineHour);
          
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "tides");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      }
    }
  }, [timeLineHour, timeLineDate]);

  const [isWaveButtonShow, setIsWaveButtonShow] = useState(false);

  useEffect(() => {
    const shouldShow = set1Order.some(
      (item) => item === "tidesnot" || item === "tides"
    );

    setIsWaveButtonShow(shouldShow);
  }, [set1Order]);

  useEffect(() => {}, [isWaveButtonShow]);

  useEffect(() => {
    if (!isWaveButtonShow) {
      if (!isWavesLoad) {
        if (isClicked == true) {
          setTimeLayer("tides");
          LocationMarkerPopup("tides");
          setIsClicked(false);
        } else if (isClicked === false) {
          setTimeLayer("tidesnot");
          LocationMarkerPopup("tidesnot");
          senddValueFromTides("tides");
          setIsClicked(true);
        }
        setIsWavesLoad(true);
      }
    } else {

      if (!isWavesLoad) {

        if(loadLayerInMap==="tides"){
          if (isClicked == true) {
            setTimeLayer("tides");
            LocationMarkerPopup("tides");
            setIsClicked(false);
          } else if (isClicked === false) {
            setTimeLayer("tidesnot");
            LocationMarkerPopup("tidesnot");
            senddValueFromTides("tides");
            setIsClicked(true);
          }
        }else if(loadLayerInMap==="tidesnot"){
          setTimeLayer("tides");
          LocationMarkerPopup("tides");
          tidesIconClick();
        }
  
        setIsWavesLoad(true);
      }
    }
  }, [loadLayerInMap]);

  function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp * 1000); // Multiply by 1000 to convert to milliseconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}-${hour}:${minute}`;
  }

  function parseDateString(dateString: string): string | null {
    const offsetMinutes = new Date().getTimezoneOffset();

    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
    const match = dateString.match(dateRegex);
    if (!match) {
      console.error("Invalid date format:", dateString);
      return null;
    }
    const [, year, month, day, hour, minute] = match;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    );
    date.setMinutes(date.getMinutes() + offsetMinutes);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    return formattedDate;
  }

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (ecmf6hStart && ecmf6hStart !== 0) {
      setIsReady(true); // Set ready state to true when ecmf6hStart is valid
    }
  }, [ecmf6hStart]);

  const resultMap = new Map<number, string>();
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-CA");

  useEffect(() => {
    if (!isReady) return;
    if (weatherlayerState === "tidesnot" && selectModel === "ECMWF") {
      setIsClicked(true);
      let i = 0;
      for (; i <= 48; i++) {
        const value = ecmf3hStart + i * ecmf3hInterval;
        if (value > ecmf3hEnd) break;
        resultMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 64; j++) {
        const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
        if (value > ecmf6hEnd) break;
        resultMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ecmf.size; i++) {
          let dateBefore = resultMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);

          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_zos`,
                STYLES: "weather:tide",
              },

              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ecmf.size); cnti++) {
                  let dateBeforeCache = resultMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);

                  queryParams.set(
                    "LAYERS",
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_zos`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;

                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_zos`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },

              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", `tides_${i}`);
          const key = resultMap.get(i);
          if (key !== undefined) {
            tidesMap.set(key, layers);
          }
          allWeatherMapECMWF("tidesEcmwf", tidesMap);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
      try {
        if (tidesMap) {
          const layer = tidesMap.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "tides");
          }
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    } else if (weatherlayerState === "flood") {
      setIsClicked(false);
      LocationMarkerPopup("tides");
    } else if (weatherlayerState === "satellite not") {
      setIsClicked(false);
      LocationMarkerPopup("tides");
    } else if (weatherlayerState === "tidesnot") {
      setIsClicked(true);
    } else {
      if (loadLayerInMap === "tides") {
        setIsClicked(true);
      } else {
        setIsClicked(false);
      }
    }
  }, [weatherlayerState, isClicked, isReady, selectModel]);

  useEffect(() => {}, [isButtonClicked]);

  useEffect(() => {}, [isClicked]);

  const [isIconReady, setIconReady] = useState(false);

  useEffect(() => {
    if (icon3hStart && icon3hStart !== 0) {
      setIconReady(true);
    }
  }, [icon3hStart]);

  const resultIconMap = new Map<number, string>();

  const cachedMap: Map<string, Map<string, boolean>> = new Map();

  async function preloadImage(
    url: string,
    bbox: string,
    layer: string
  ): Promise<void> {
    try {
      const cache = await caches.open("image-cache");
      const cachedResponse = await cache.match(url);

      let cachedByLayer: Map<string, boolean> = new Map();

      if (cachedMap.get(bbox) != null) {
        cachedByLayer = cachedMap.get(bbox)!;
      } else {
        cachedMap.set(bbox, cachedByLayer);
      }

      if (
        cachedByLayer.get(layer) != null &&
        cachedByLayer.get(layer) == true
      ) {
      } else {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          await cache.put(url, new Response(blob));

          const imgElement = document.createElement("img");
          imgElement.src = url;
          cachedByLayer.set(layer, true);
          cachedMap.set(bbox, cachedByLayer);
        } else {
          cachedByLayer.set(layer, false);
          cachedMap.set(bbox, cachedByLayer);
          console.error("Failed to fetch image:", response.statusText);
        }
      }
    } catch (error) {
      console.error("Error during image caching and preload:", error);
    }
  }

  useEffect(() => {
    if (!isIconReady) return;

    if (selectModel === "ICON" && weatherlayerState === "tidesnot") {
      let i = 0;
      for (; i <= 78; i++) {
        const value = icon1hStart + i * icon1hInterval;
        if (value > icon1hEnd) break;
        resultIconMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 112; j++) {
        const value = icon3hStart + (j - 78) * icon3hInterval;
        if (value > icon3hEnd) break;
        resultIconMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ICON.size; i++) {
          let dateBefore = resultIconMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);
          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerIconStartDate}_icon_${dayPass}:00_zos`,
                STYLES: "weather:tide",
              },
              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ICON.size); cnti++) {
                  let dateBeforeCache = resultIconMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);

                  queryParams.set(
                    "LAYERS",
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_zos`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;

                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_zos`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },

              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", `tides_${i}`);
          const key = resultIconMap.get(i);
          if (key !== undefined) {
            tidesMapIcon.set(key, layers);
          }
          allWeatherMapICON("tidesMapIcon", tidesMapIcon);
        }
        // ----------------------------------for fix duplicate error-----------------
        weatherLayerGroup.getLayers().clear();
        try {
          if (tidesMapIcon) {
            const layer = tidesMapIcon.get(timeLineDate + "-" + timeLineHour);
            if (layer) {
              getGlobalLayer(layer);
              toGroupLayers(layer, false, "tides");
            }
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
  }, [selectModel, isIconReady, weatherlayerState]);

  const tidesIconClick = async () => {
    try {
      let tidesLayerMap;
      if (selectModel === "ECMWF") {
        tidesLayerMap = weatherMapECMF.get("tidesEcmwf");
      } else if (selectModel === "ICON") {
        tidesLayerMap = weatherMapICON.get("tidesMapIcon");
      }

      if (tidesLayerMap) {
        const layer = tidesLayerMap.get(timeLineDate + "-" + timeLineHour);
        if (layer) {
          toGroupLayers(layer, true, "tides");
        }
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  return (
    <div>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            setTimeLayer("tides");
            LocationMarkerPopup("tides");
            selectLayerInMap("tidesnot");
            tidesIconClick();
          } else if (isClicked === false) {
            setTimeLayer("tidesnot");
            LocationMarkerPopup("tidesnot");
            senddValueFromTides("tides");
            selectLayerInMap("tides");
          }
        }}
        onTouchStart={() => {
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            setTimeLayer("tides");
            LocationMarkerPopup("tides");
            tidesIconClick();
          } else if (isClicked === false) {
            setTimeLayer("tidesnot");
            LocationMarkerPopup("tidesnot");
            senddValueFromTides("tides");
          }
        }}
      >
        <div
          onMouseEnter={() => setHoveredTights(true)}
          onMouseLeave={() => setHoveredTights(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faHouseTsunami}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked-light"
                : hoveredTights
                ? "leftsidemenulist-btn-tooltip-hover-light"
                : "leftsidemenulist-btn-tooltip-light"
            }
            onMouseEnter={() => setHoveredTights(true)}
            onMouseLeave={() => setHoveredTights(false)}
          >
            Tides
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked"
                : hoveredTights
                ? "leftsidemenulist-btn-tooltip-hover"
                : "leftsidemenulist-btn-tooltip"
            }
            onMouseEnter={() => setHoveredTights(true)}
            onMouseLeave={() => setHoveredTights(false)}
          >
            Tides
          </div>
        )}
      </div>
    </div>
  );
};
export default Waves;
